const orderedCategories: Oneflow.Extension['category'][] = [
  'addons',
  'create',
  'collaborate',
  'sign',
  'ai',
  'manage',
  'analyze',
  'user_management',
  'integrations',
  'sales_and_crm',
  'people_culture',
  'productivity',
  'automation',
  'support',
];

type CategorizedExtension = {
  title: string;
  category: Oneflow.Extension['category'];
  extensions: Oneflow.Extension[];
};

export const categorize = (extensions: Oneflow.Extension[]): CategorizedExtension[] => {
  const categorizedMap = extensions.reduce((acc, extension) => {
    const { category, categoryReadable } = extension;
    if (!acc[category]) {
      acc[category] = {
        title: categoryReadable || category,
        category,
        extensions: [],
      };
    }
    acc[category].extensions.push(extension);
    return acc;
  }, {} as Record<Oneflow.Extension['category'], CategorizedExtension>);

  return orderedCategories
    .filter((category) => categorizedMap[category])
    .map((category) => categorizedMap[category]);
};

type Props = {
  categoryReadable: string,
};

export const ExtensionCategory = ({ categoryReadable }: Props) => (
  <>
    {categoryReadable}
  </>
);
